export const TOTAL_SLIDES = 5

export const TOTAL_SLIDES_INCOME = 5

export const TOTAL_SLIDES_AFFORD = 3

export const PREVIOUS = 'PREV'

export const NEXT = 'NEXT'

export const CALCULATE = 'CALCULATE'

export const CALCULATE_BUTTON = 'Calculate'

export const RECALCULATE = 'Recalculate'

export const CURRENCY_SIMBOL = '£'

// const for getting input values from quiz => tab 1

export const ANUALL_INCOME = 'income'

export const ADDITIONAL_INCOME = 'additionalIncome'

export const DEBT_TOTAL = 'debt'

export const TOTAL_DEPOSIT = 'TOTAL_DEPOSIT'

export const CHILDREN_TOTAL = 'CHILDREN_TOTAL'

// const for getting input values from quiz => tab 2

export const AFFORD_SAVED_MONEY = 'deposit'

export const AFFORD_MONTHLY_RATE = 'monthly'

export const AFFORD_DURATION = 'term'

// OVERPAYMENT CALC COSNT

export const OUTSTANDING_BALANCE = 'OUTSTANDING_BALANCE'

export const OVERPAYMENT_YEAR = 'OVERPAYMENT_YEAR'

export const OVERPAYMENT_MONTH = 'OVERPAYMENT_MONTH'

export const OVERPAYMENT_ANNUAL_INTEREST = 'OVERPAYMENT_ANNUAL_INTEREST'

export const OVERPAYMENT_ONE_OFF = 'OVERPAYMENT_ONE_OFF'

export const OVERPAYMENT_RECURRING = 'OVERPAYMENT_RECURRING'
